"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _UpdateMarketingFreeSettings = _interopRequireDefault(require("settings-ui-modules/marketing/modules/collected-forms/stagedObjects/UpdateMarketingFreeSettings"));

var _default = (0, _redux.combineReducers)({
  updateMarketingFreeSettings: _UpdateMarketingFreeSettings.default.getReducer()
});

exports.default = _default;
module.exports = exports.default;